import { useEffect, useState, useContext, useCallback } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import useToken from "../../hooks/useToken";
import { DataContext, DataProvier } from "./data/DataContext";
import { siteTitleMain, lstPageTitle, stepEnum, catVehicleBrand, typeCobEnum, catCivilStatus } from './data/MochaData';
import { usePage } from './hook';
import { SiteConfig, AutoDataLoad } from './data/Data';
import { LineProgressBar, ButtonCtrl, PagesTitleCtrl, ModalMsgCtrl, ModalSave } from './components'
import { Step } from "./step";
import http from "../../services/http";
import { endPoints, especialCoverage } from "../../utils/constanst";
import Modal from 'react-modal'
import { IconError } from './img'


import './Auto_cr.css';
import { useModal } from "./hook/useModal";
import {
    IsValidString,
    GetDataRates,
    BuilData,
    isSpecialEquipment,
    BuildDataOportunity,
    BuildDataNotificationOportunitySL,
    BuildNotificationCliente
} from './data/Help';


const Auto = () => {

    const { loading } = useToken();

    useEffect(() => {
        if (!loading) {
            const preloader: any = document.querySelector(".site-preloader");
            if (preloader) {
                preloader.addEventListener("transitionend", (event: any) => {
                    if (event.propertyName === "opacity") {
                        preloader.parentNode.removeChild(preloader);
                    }
                });
                preloader.classList.add("site-preloader__fade");
            }
        }
    }, [loading]);

    if (loading) return (<></>);
    return (
        <DataProvier loading={loading} >
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Switch>
                    <Route exact path="/micrositio/cr/auto" component={Layout} />
                </Switch>
            </BrowserRouter>
        </DataProvier>
    );
}

const Layout = ({ }) => {
    const { AutoCR, setAutoCR } = useContext(DataContext);
    const page = usePage(SiteConfig.InitPage, lstPageTitle);
    const modalLoading = useModal({ isloading: true } as IModalProps);
    const [modalCreate, setModalCreate] = useState(false);
    const modalNoAuth = useModal({ isloading: false, active: false } as IModalProps);
    const modalMailNoValid = useModal({ isloading: false, active: false } as IModalProps);

    useEffect(() => {

    }, [])

    useEffect(() => {
        if (IsValidString(AutoCR.plan) && !AutoCR.isEdit)
            GetDataPlan();
        else if (!AutoCR.isEdit)
            setAutoCR({ ...AutoCR, catCoverage: [], catBranch: [], otherVehicleBrand: '', vehicleModel: '', catModel: [], vehicleBrand: '' })
    }, [AutoCR.plan])


    useEffect(() => {

        if (AutoCR.vehicleBrand === '0' && IsValidString(AutoCR.plan) && !AutoCR.isEdit)
            GetBranch();
        else if (!AutoCR.isEdit)
            setAutoCR({ ...AutoCR, catBranch: [], otherVehicleBrand: '', vehicleModel: '', catModel: [] })
    }, [AutoCR.vehicleBrand])

    useEffect(() => {

        if (((IsValidString(AutoCR.vehicleBrand) && AutoCR.vehicleBrand !== '0') || (IsValidString(AutoCR.otherVehicleBrand) && AutoCR.vehicleBrand === '0')) && !AutoCR.isEdit)
            GetModel()
        else if (!AutoCR.isEdit)
            setAutoCR({ ...AutoCR, catModel: [], vehicleModel: '' })

    }, [AutoCR.vehicleBrand, AutoCR.otherVehicleBrand])

    useEffect(() => {

        if (IsValidString(AutoCR.vehicleModel) && !AutoCR.isEdit)
            GetYear();
        else if (!AutoCR.isEdit)
            setAutoCR({ ...AutoCR, catYear: [], vehicleYear: '' })
    }, [AutoCR.vehicleModel])



    useEffect(() => {
        if (IsValidString(AutoCR.vehicleYear) && !AutoCR.isEdit)
            GetDataSheet();
    }, [AutoCR.vehicleYear])

    const GetBranchAuto = () => {
        if (IsValidString(AutoCR.vehicleBrand) && AutoCR.vehicleBrand !== '0')
            return AutoCR.vehicleBrand;
        if (IsValidString(AutoCR.otherVehicleBrand) && AutoCR.vehicleBrand === '0')
            return AutoCR.otherVehicleBrand;
        else
            return ''
    }

    useEffect(() => {
        if (AutoCR.isRate)
            modalLoading.show('Tarificando...');
        else
            modalLoading.hide();
    }, [AutoCR.isRate])

    useEffect(() => {
        if (AutoCR.loadedPolicy)
            LoadPolicy();
    }, [AutoCR.loadedPolicy])



    const Submit = () => {
        let result = document.querySelector("form") as HTMLFormElement;
        if (result.reportValidity() === false) return;
        switch (page.index) {
            case stepEnum.step1:
                GetInfoEnte();
                break;
            case stepEnum.step2:
                if (AutoCR.offerType === '1' && !AutoCR.isEdit)
                    GetInitStep2();
                else if (AutoCR.offerType === '0' && AutoCR.isEdit)
                    page.Increment();
                break;
            case stepEnum.step3:
                if (AutoCR.isDatasheet)
                    page.Increment();
                else
                    modalLoading.setTextMsgWithClose("Este vehiculo no es asegurable");
                break;
            case stepEnum.step4:
                if (AutoCR.isDatasheet)
                    GetRates();
                break;
            // case stepEnum.step5:
            //     ValidateMail();
            //     break;
            case stepEnum.step6:
                //Create();
                //SendNotificationOportunitySL();
                //GetInitStep6();
                //NewCreate();
                ValidateMail();
                break;
            default:
                modalLoading.hide();
                page.Increment();
                break;
        }
    }

    const ValidateMail = () => {

        modalLoading.show(`Validando correo ${AutoCR.mail}...`)
        http(endPoints.validateMail).post({
            correo: AutoCR.mail,
            aplicacion: "Micro Auto Correduria"
        }).then(() => {
            modalLoading.hide();
            NewCreate();
        }).catch(() => {
            modalLoading.hide();
            modalMailNoValid.show();
        })
    }

    const GetInfoEnte = () => {
        modalLoading.setTextLoading('Cargando información...')
        http(endPoints.ente(AutoCR.identification, AutoCR.typeDocument)).get()
            .then((x) => {
                if (x.idCorreduria === 0)
                    modalNoAuth.show(); //GoToUrlClient();
                else {
                    setAutoCR({ ...AutoCR, username: x.username, idBrokerage: x.idCorreduria, nameBrokerage: x.nombreCorreduria, idUser: x.idExterno });
                    page.Increment();
                }
            })
            .catch((error) => {
                modalNoAuth.show();//GoToUrlClient();
            })
            .finally(() => {
                modalLoading.hide()
                //GetInitStep2();
            })
    }

    const GoToUrlClient = () => window.location.href = '/ProductosDigitales/micrositio/automovilcr';

    const GetInitStep2 = () => {
        modalLoading.show('Cargando...')
        Promise.allSettled([
            GetPlansByUser(),
            GetUseVeh(),
        ]).then(x => {
            let catPlan: Array<ICatalog> = [];
            let configPlan = {};
            let catUse = [];

            if (x[0].status === 'fulfilled') {
                x[0].value.forEach((x: IPlanConfig) => {
                    catPlan.push({
                        value: x.id.toString(),
                        text: x.nombre
                    } as ICatalog);
                })
                configPlan = x[0].value;
            }

            if (x[1].status === 'fulfilled')
                catUse = x[1].value;
            setAutoCR({ ...AutoCR, catPlanConfig: catPlan, lstPlanConfig: configPlan, catUse: catUse })
            page.Increment();
        })
            .finally(() => modalLoading.hide())
    }

    const GetInitStep6 = () => {
        setModalCreate(true);
        Promise.allSettled([
            Create(),
            CreateOportunity()
        ]).then(x => { console.log(x) })
            .catch(x => { })
    }

    const GetPlansByUser = () => http(endPoints.configPlansUser(1, AutoCR.username)).get();

    const GetBranch = () => {
        modalLoading.show('Cargando otras marcas...')
        http(endPoints.brands(AutoCR.plan)).get()
            .then(x => {
                if (AutoCR.isEdit)
                    setAutoCR({ ...AutoCR, catBranch: x })
                else
                    setAutoCR({ ...AutoCR, catBranch: x, vehicleModel: '', vehicleYear: '' })
            }).finally(() => modalLoading.hide())
    }

    const GetModel = () => {
        modalLoading.show('Cargando modelos...');
        http(endPoints.models(AutoCR.plan, GetBranchAuto()))
            .get()
            .then(x => {
                if (AutoCR.isEdit)
                    setAutoCR({ ...AutoCR, catModel: x })
                else
                    setAutoCR({ ...AutoCR, catModel: x, vehicleModel: '', vehicleYear: '' })
            })
            .finally(() => modalLoading.hide());
    }

    const GetYear = () => {
        modalLoading.show('Cargando año...')
        http(endPoints.lastYearNumber(AutoCR.plan, GetBranchAuto(), AutoCR.vehicleModel, 10))
            .get()
            .then((x) => {
                if (AutoCR.isEdit)
                    setAutoCR({ ...AutoCR, catYear: x })
                else
                    setAutoCR({ ...AutoCR, catYear: x, vehicleYear: '' })
            })
            .finally(() => modalLoading.hide());
    }

    const GetUseVeh = () => http(endPoints.vhUses).get();

    const GetCoverages = () => http(endPoints.coverages(AutoCR.plan)).get()

    const GetDeductible = () => http(endPoints.deductibles(AutoCR.plan)).get()

    const GetFess = () => http(endPoints.fees(AutoCR.plan)).get()

    const GetDiscount = () => http(endPoints.discountByPlan(AutoCR.plan)).get()


    const GetDataPlan = () => {
        modalLoading.show('Cargando datos del plan...')
        Promise.allSettled([
            GetCoverages(),
            GetDeductible(),
            GetFess(),
            GetDiscount()
        ]).then(x => {
            let coverAdd: Array<ICoveragesExt> = []
            let catDed: Array<ICatalog> = []
            let catQuotas: Array<ICatalog> = []
            let data: ICoveragesPlan = {} as ICoveragesPlan
            let discountDat = [] as Array<IDiscount>
            if (x[0].status === 'fulfilled') {
                data = x[0].value;
                data.coverages.map((cov: ICoverages) => {
                    let typeCob = typeCobEnum.DEFAULT
                    let sumCat = data.sumInsureds.filter(sum => sum.id === cov.idCob).map(m => ({ text: m.text, value: m.value } as ICatalog));
                    if (sumCat.length > 0)
                        typeCob = typeCobEnum.COMBO;
                    if (cov.idCob === especialCoverage.equipoEspecialCR)
                        typeCob = typeCobEnum.ESPECIAL_COB
                    coverAdd.push({ ...cov, type: typeCob, catalog: sumCat, checked: false } as ICoveragesExt)
                });
            }
            if (x[1].status === 'fulfilled')
                catDed = x[1].value
            if (x[2].status === 'fulfilled')
                catQuotas = x[2].value.map((x: any) => { return { text: x.text, value: x.value, text2: x.description } as ICatalog })
            if (x[3].status === 'fulfilled')
                discountDat = x[3].value

            let planSelected = AutoCR.lstPlanConfig.find(x => x.id === parseInt(AutoCR.plan))
            let maxDiscount = 0;
            let currency = '';
            if (planSelected !== undefined && planSelected !== null) {
                maxDiscount = planSelected.porcentajeDescManual;
                currency = planSelected.moneda;
            }

            if (AutoCR.isEdit)
                setAutoCR({
                    ...AutoCR,
                    catCoverage: data,
                    lstCoverageExt: coverAdd,
                    catDeductible: catDed,
                    catQuotas: catQuotas,
                    catDiscount: discountDat,
                    maxDiscount: maxDiscount,
                    idDiscount: 0,
                    currency: currency
                })
            else
                setAutoCR({
                    ...AutoCR,
                    catCoverage: data,
                    lstCoverageExt: coverAdd,
                    catBranch: [],
                    otherVehicleBrand: '',
                    vehicleModel: '',
                    catModel: [],
                    catDeductible: catDed,
                    catQuotas: catQuotas,
                    vehicleBrand: '',
                    catDiscount: discountDat,
                    maxDiscount: maxDiscount,
                    idDiscount: 0,
                    currency: currency
                })

        })
            .finally(() => modalLoading.hide())

    }

    const GetDataSheet = () => {
        if (IsValidString(GetBranchAuto()) &&
            IsValidString(AutoCR.vehicleModel) &&
            IsValidString(AutoCR.vehicleYear) &&
            IsValidString(AutoCR.plan)) {
            modalLoading.show('Cargando datos del vehiculo...')
            http(endPoints.datasheet(AutoCR.plan, AutoCR.vehicleBrand === '0' ? AutoCR.otherVehicleBrand : AutoCR.vehicleBrand, AutoCR.vehicleModel, AutoCR.vehicleYear))
                .get()
                .then((x) => {
                    setAutoCR({ ...AutoCR, datasheet: x, isDatasheet: true })
                }).catch(x => setAutoCR({ ...AutoCR, datasheet: {}, isDatasheet: false }))
                .finally(() => modalLoading.hide());
        }

    }


    const GetRates = () => {
        modalLoading.show('Tarificando...')
        const data = GetDataRates(AutoCR)
        http(endPoints.tarificar(AutoCR.plan))
            .post(data)
            .then((x) => {
                modalLoading.hide()
                setAutoCR({ ...AutoCR, rates: x });
                page.Increment();
            })
            .catch((x: string) => {
                modalLoading.setTextMsgWithClose(x.replaceAll('"', '').replaceAll('\n', '').replaceAll('\r', ''));
            })
    }


    const Create = () => {
        setModalCreate(true);
        const data = BuilData(AutoCR, '');
        let dataNotification = BuildNotificationCliente(AutoCR);
        if (AutoCR.isEdit) {
            return http(endPoints.updateCotizador)
                .put(data)
                .then(x => {
                    setAutoCR({ ...AutoCR, saved: true });
                    http(endPoints.sendNotficationNew).post(dataNotification)
                        .then(() => {
                            page.Increment(); setModalCreate(false);
                            http(endPoints.descargarOferta(x.id)).get().catch(() => () => modalLoading.hide()).finally(() => modalLoading.hide());
                        })
                        .catch(() => { page.Increment(); setModalCreate(false); })
                })
                .catch(() => {
                    setAutoCR({ ...AutoCR, saved: false })
                    page.Increment();
                    setModalCreate(false);
                })
        }
        else {
            return http(endPoints.createCotizadorCr)
                .post(data)
                .then(x => {
                    setAutoCR({ ...AutoCR, idPoliza: x.id, saved: true })
                    dataNotification.values = { ...dataNotification.values, 'idpoliza': x.id }
                    http(endPoints.sendNotficationNew).post(dataNotification)
                        .then(() => {
                            page.Increment(); setModalCreate(false);
                            modalLoading.setTextLoading(`Descargando oferta #${x.id}`);
                            http(endPoints.descargarOferta(x.id)).get().catch(() => () => modalLoading.hide()).finally(() => modalLoading.hide());
                        })
                        .catch(() => { page.Increment(); setModalCreate(false); })
                })
                .catch(() => {
                    setAutoCR({ ...AutoCR, saved: false })
                    page.Increment();
                    setModalCreate(false);
                })
        }
    }

    const NewCreate = () => {
        setModalCreate(true);
        const data = BuilData(AutoCR, '');

        const endpoint = AutoCR.isEdit ? endPoints.updateCotizador : endPoints.createCotizadorCr;
        const method = AutoCR.isEdit ? 'put' : 'post';
        const promiseCreateUpdate = http(endpoint)[method](data);

        promiseCreateUpdate
            .then((x) => {
                page.Increment(); setModalCreate(false);
                const dataResult = x;
                const updatedAutoCR = AutoCR.isEdit
                    ? { ...AutoCR, saved: true }
                    : { ...AutoCR, idPoliza: dataResult.id, saved: true };

                setAutoCR(updatedAutoCR);

                let id = AutoCR.isEdit ? AutoCR.idPoliza : dataResult.id;
                let data = BuildDataOportunity(AutoCR, '');
                data.IdPoliza = id;
                data.NoOferta = id;
                let dataNotification = BuildNotificationCliente(AutoCR);
                dataNotification.values = { ...dataNotification.values, 'idpoliza': id };
                modalLoading.show(`Descargando oferta #${id}...`);
                Promise.allSettled([
                    http(endPoints.sendNotficationNew).post(dataNotification),
                    http(endPoints.descargarOferta(id)).get(),
                    http(endPoints.createOportunityNew).post(data)
                ]).then((res) => {
                    if (res[0].status === "rejected"){
                        modalLoading.hide();
                        return;
                    }
                    if (res[2].status === "fulfilled") {
                        var resOportunity = res[2].value;                        
                        const dataNotificationSalesforce = BuildDataNotificationOportunitySL(AutoCR)
                        dataNotificationSalesforce.values = { ...dataNotificationSalesforce.values, '__oportunidad__': resOportunity.message };
                        Promise.allSettled([
                            http(endPoints.sendNotificatioOportunitySL).post(dataNotificationSalesforce),
                            //http(endPoints.updateOportunityLogPolicy(resOportunity.message,id)).get()
                        ]).then(() => modalLoading.hide())
                    }
                    else
                        modalLoading.hide()
                })
            })
            .catch((error) => {
                page.Increment(); setModalCreate(false);
                console.error('Error al crear o actualizar el cotizador:', error);
                CreateOportunity();

            });

    }

    const LoadPolicy = () => {
        modalLoading.show(`Cargando oferta #${AutoCR.idPoliza}`)
        http(endPoints.getPolicy(AutoCR.idPoliza))
            .get()
            .then(result => {
                //GetInitStep2();
                let marc = catVehicleBrand.find(t => t.value === result.oa.cmarca.toString())

                Promise.allSettled([
                    http(endPoints.coverages(result.plan)).get(),
                    http(endPoints.deductibles(result.plan)).get(),
                    http(endPoints.fees(result.plan)).get(),
                    http(endPoints.discountByPlan(result.plan)).get(),
                    http(endPoints.configPlansUser(1, AutoCR.username)).get(),
                    http(endPoints.vhUses).get(),
                    http(endPoints.brands(result.plan)).get(),
                    http(endPoints.models(result.plan, result.oa.cmarca)).get(),
                    http(endPoints.lastYearNumber(result.plan, result.oa.cmarca, result.oa.cmodelo, 10)).get(),
                    http(endPoints.datasheet(result.plan, result.oa.cmarca, result.oa.cmodelo, result.oa.auAnio))
                ]).then(x => {
                    let coverAdd: Array<ICoveragesExt> = []
                    let catDed: Array<ICatalog> = []
                    let catQuotas: Array<ICatalog> = []
                    let data: ICoveragesPlan = {} as ICoveragesPlan
                    let catPlan: Array<ICatalog> = [];
                    let configPlan = [];
                    let catUse = [];
                    let catBrand: Array<ICatalog> = []
                    let catModel: Array<ICatalog> = []
                    let catYear: Array<ICatalog> = []
                    let datasheet = {};
                    let isDatasheet: boolean = false;
                    let descount: number = 0;
                    let idDiscount: number = 0;

                    let discountDat = [] as Array<IDiscount>
                    if (x[0].status === 'fulfilled') {
                        data = x[0].value;
                        data.coverages.map((cov: ICoverages) => {
                            let sa = ''
                            let sumCat = data.sumInsureds.filter(sum => sum.id === cov.idCob).map(m => ({ text: m.text, value: m.value } as ICatalog));
                            let existCob = result.polCobs.find((x: any) => x.idCob === cov.idCob)

                            let typeCob = typeCobEnum.DEFAULT
                            let kitSpecialName = '';
                            let kitSpecialSA = undefined;

                            if (existCob !== null && existCob !== undefined)
                                sa = existCob.etiqueta;
                            if (sumCat.length > 0)
                                typeCob = typeCobEnum.COMBO;
                            if (isSpecialEquipment(cov.idCob)) {
                                typeCob = typeCobEnum.ESPECIAL_COB;
                                if (result.oa?.oA_EquipoEspecial !== undefined && result.oa?.oA_EquipoEspecial !== null && result.oa?.oA_EquipoEspecial.length > 0) {
                                    kitSpecialName = result.oa?.oA_EquipoEspecial[0].observaciones
                                    kitSpecialSA = result.oa?.oA_EquipoEspecial[0].valor
                                }
                            }
                            coverAdd.push({
                                ...cov,
                                type: typeCob,
                                catalog: sumCat,
                                checked: (existCob !== null && existCob !== undefined),
                                sa: sa,
                                kitSpecialName: kitSpecialName,
                                kitSpecialSA: kitSpecialSA
                            } as ICoveragesExt)
                        });
                    }
                    if (x[1].status === 'fulfilled')
                        catDed = x[1].value
                    if (x[2].status === 'fulfilled')
                        catQuotas = x[2].value.map((x: any) => { return { text: x.text, value: x.value, text2: x.description } as ICatalog })
                    if (x[3].status === 'fulfilled')
                        discountDat = x[3].value

                    if (x[4].status === 'fulfilled') {
                        x[4].value.forEach((x: IPlanConfig) => {
                            catPlan.push({
                                value: x.id.toString(),
                                text: x.nombre
                            } as ICatalog);
                        })
                        configPlan = x[4].value;
                    }

                    let planSelected = configPlan.find((x: any) => x.id === parseInt(result.plan))
                    let maxDiscount = 0;
                    if (planSelected !== undefined && planSelected !== null)
                        maxDiscount = planSelected.porcentajeDescManual;

                    if (x[5].status === 'fulfilled')
                        catUse = x[5].value;
                    if (x[6].status === 'fulfilled')
                        catBrand = x[6].value;
                    if (x[7].status === 'fulfilled')
                        catModel = x[7].value;
                    if (x[8].status === 'fulfilled')
                        catYear = x[8].value;
                    if (x[9].status === 'fulfilled') {
                        datasheet = x[9].value;
                        isDatasheet = true
                    }

                    if (result?.polCobsDesc?.length > 0) {
                        let firstDesc = result.polCobsDesc[0];
                        console.log(firstDesc)
                        descount = firstDesc.pdescuento;
                        idDiscount = parseInt(firstDesc.codDesc);
                    }

                    let civilStatusVal = '';
                    let civilStatusCat = catCivilStatus.find(x => x.text2 === result.aseguradoNavigation.estadoCivil)
                    if (civilStatusCat !== undefined && civilStatusCat !== null)
                        civilStatusVal = civilStatusCat.value

                    let currency = '';
                    if (planSelected !== undefined && planSelected !== null) {
                        maxDiscount = planSelected.porcentajeDescManual;
                        currency = planSelected.moneda;
                    }               

                    let marc2 = undefined
                    if(marc?.value !== "0")
                        marc2 = marc?.value
                
                    setAutoCR({
                        ...AutoCR,
                        loadedPolicy: false,
                        
                        plan: result.plan,
                        vehicleBrand: marc2 === undefined ? '0' : result.oa.cmarca.toString(),
                        otherVehicleBrand: marc2 === undefined ? result.oa.cmarca.toString() : undefined,
                        vehicleModel: result.oa.cmodelo.toString(),
                        vehicleYear: result.oa.auAnio.toString(),
                        vehicleStatus: result.oa.auValorNuevo ? "1" : "2",
                        vehicleUse: result.oa.auUso,
                        vehicleDevice: result.oa.irastreoSatelital?.toString(),
                        vehicleValue: result.oa.auValorNuevo,
                        deductible: result.oa.ideducible.toString(),
                        quotas: result.cuotas.toString(),
                        typeDocumentInsured: result.aseguradoNavigation.tipoId,
                        identificationInsured: result.aseguradoNavigation.numId,
                        firstName: result.aseguradoNavigation.nombre,
                        lastName: result.aseguradoNavigation.apellido,
                        mail: result.aseguradoNavigation.email,
                        phone: result.aseguradoNavigation.telefonoCelular,
                        civilStatus: civilStatusVal,
                        isEdit: true,
                        catCoverage: data,
                        lstCoverageExt: coverAdd,
                        catDeductible: catDed,
                        catQuotas: catQuotas,
                        catDiscount: discountDat,
                        maxDiscount: maxDiscount,
                        catBranch: catBrand,
                        catModel: catModel,
                        catYear: catYear,
                        catUse: catUse,
                        catPlanConfig: catPlan,
                        lstPlanConfig: configPlan,
                        datasheet: datasheet,
                        isDatasheet: isDatasheet,
                        discount: descount,
                        idDiscount: idDiscount,
                        currency: currency
                    })
                    page.Increment();
                }).finally(() => {
                    modalLoading.hide();

                })

                modalLoading.hide()
                loadCatalogEdit()

            }).catch(() => {
                modalLoading.hide()
                setAutoCR({ ...AutoCR, loadedPolicy: false })
            })
            .finally(() => { });

    }

    const CreateOportunity = () => {
        modalLoading.show();
        const data = BuildDataOportunity(AutoCR, '');
        http(endPoints.createOportunityNew).post(data)
            .then(x => {
                const dataNotification = BuildDataNotificationOportunitySL(AutoCR)
                dataNotification.values = { ...dataNotification.values, '__oportunidad__': x.message };
                http(endPoints.sendNotificatioOportunitySL).post(dataNotification);
            }).finally(() => modalLoading.hide())
    }

    const SendNotificationOportunitySL = () => {
        const data = BuildDataNotificationOportunitySL(AutoCR)
        http(endPoints.sendNotificatioOportunitySL).post(data);
    }


    const loadCatalogEdit = () => {
        modalLoading.show('Cargando datos...')

    }



    return (
        <>
            <div className='container'>
                <div className='layout-auto-cr'>
                    {siteTitleMain[page.index] !== '' &&
                        <>
                            <div className="mt-10">
                                <p className="lbl-title title-1">{siteTitleMain[page.index].replace('$nom.bre_corrdr', AutoCR.nameBrokerage)}</p>
                                <p className="lbl-title title-2">
                                    {page.index === 0 &&
                                        <span>Ofrece a tus clientes tranquilidad y confianza en cada momento con el Seguro de Auto LAFISE Plus.</span>}
                                    {(page.index !== 0 && page.index !== 5) &&
                                        <span>Con tu póliza de Auto LAFISE Plus, disfruta cada momento sin preocupaciones</span>}
                                    {(page.index !== 0 && page.index === 5) &&
                                        <span>Por favor, ingresa los datos personales del cliente según aparecen en su documento de identidad. Esta información es indispensable para completar su oferta</span>}
                                </p>
                            </div>
                            <LineProgressBar index={page.index} totalPages={SiteConfig.TotalPageBar} />
                        </>
                    }

                    <form>
                        <div style={{ display: "flex" }}>
                            <div className="step-container-auto-cr">
                                <PagesTitleCtrl {...page.actualPage} />
                                <Step {...page.actualPage} />
                            </div>
                        </div>
                        <ButtonCtrl data={(AutoCR.offerType === '2' && stepEnum.step2 === page.index) ? { ...page.actualPage, txtBtnNext: '' } : page.actualPage} submit={Submit} back={page.Decrement} />
                    </form>
                </div>
                <ModalMsgCtrl {...modalLoading.modal} closeModal={modalLoading.hide} />

                <ModalSave active={modalCreate} />

                <Modal className='modal' isOpen={modalNoAuth.modal.active}>
                    <div className='pt-20 pb-20'>
                        <div className='img-wm' >
                            <IconError />
                        </div>
                        <div className="">
                            <p className="text-center modal-lbl lbl-color modal-lbl-t2 mb-50">
                                Recorda que para poder hacer <br /> uso del formulario de  <br /> corredores es requerido que  <br /> tengas un usuario activo en  <br /> seguronet.
                            </p>
                            <div className="mb-20" style={{ display: 'flex', justifyContent: 'center' }}>
                                <button className="btn-auto-cr  back-auto-cr" onClick={() => { modalNoAuth.hide(); }}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal className='modal' isOpen={modalMailNoValid.modal.active}>
                    <div className='pt-20 pb-20'>
                        <div className='img-wm' >
                            <IconError />
                        </div>
                        <div className="">
                            <p className="text-center modal-lbl lbl-color modal-lbl-t2 mb-50">
                                La dirección de correo electrónico proporcionada no es válida
                            </p>
                            <div className="mb-20" style={{ display: 'flex', justifyContent: 'center' }}>
                                <button className="btn-auto-cr  back-auto-cr" onClick={() => { modalMailNoValid.hide(); }}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>

        </>
    );
}

export default Auto;